import React from 'react'
import {
  StyleProp,
  TouchableOpacity,
  ViewStyle,
  Text,
  TextStyle,
  StyleSheet,
} from 'react-native'

type Props = {
  onPress: () => void
  label: string
  buttonStyle?: StyleProp<ViewStyle>
  textStyle?: StyleProp<TextStyle>
  disabled?: boolean
  testID?: string
}

const Button: React.FC<Props> = ({
  onPress,
  label,
  buttonStyle,
  textStyle,
  disabled,
  testID,
}) => {
  return (
    <TouchableOpacity
      style={[styles.button, buttonStyle, disabled && styles.disabledButton]}
      onPress={onPress}
      disabled={disabled}
      testID={testID}
    >
      <Text
        style={[
          styles.buttonText,
          textStyle,
          disabled && styles.disabledButtonText,
        ]}
      >
        {label}
      </Text>
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  button: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    backgroundColor: '#00A0F3',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    height: 48,
  },
  buttonText: {
    color: '#FFFFFF',
    fontWeight: '700',
    fontSize: 16,
    lineHeight: 24,
    fontFamily: 'Inter',
  },
  disabledButton: {
    backgroundColor: '#DEE5EB',
  },
  disabledButtonText: {
    color: '#99ADBA',
  },
})

export default Button
